import { StyledCard } from '@app/components/card/Card';
import { PageMeta } from '@app/components/meta/Meta';

export const NotFound = () => {
	return (
		<>
			<PageMeta title="Not Found" />

			<StyledCard style={{ width: '100%', maxWidth: 480 }}>
				<h1 className="h2">Not Found</h1>
				<p>The page that you were looking for could not be found.</p>
			</StyledCard>
		</>
	);
};

export default NotFound;
